import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.DescargaZEDTO;
import { columnas } from "./columns";
const resource = resources.DescargaZE;
interface props {
    idChofer: number | undefined;
    permisos: models.Rol;
}

class DescargaZEListNoRX extends React.PureComponent<props> {
    modalManager = kea.createModalManager();
    idChofer = (x: props) => x.idChofer;
    noTieneChofer = createSelectorRx(this.idChofer, idChofer => idChofer == undefined);

    items = observeResource(resource.Query);
    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);

    onDelete = async (x: Entity) => {
        if (await kea.yesno("¿Eliminar carga de zona extendida?", "" + x.Folio)) {
            await resource.Delete(x.IdRegistro);
            await kea.message("La carga de zona extendida ha sido eliminada");
        }
    }

    onAgregar = async () => {
        var ccc = await this.modalManager.showModal(CrearDescargaModal, undefined, null );
        var idChofer = ccc.value?.IdChofer == null ? 0 : ccc.value.IdChofer
        debugger;
        if (idChofer > 0) {
            if (this.props.permisos.DescargaZE.Iniciar) {
                var idNuevo = await resource.IniciarDescargaZE(idChofer);
                history.go(`./${idNuevo}`);
            } else {
                await kea.message("No tiene Permisos", "Debe tener permisos de iniciar descarga en zona extendida", "error");
            }
        }
    }

    onRegresar = () => history.go('../');

    render() {
        const cols = columnas(this, this.props.permisos);
        return (
            <div>
                <kea.Title titulo="Descargas de zona extendida" onRegresar={this.onRegresar}>
                    {
                        this.props.permisos.DescargaZE.Iniciar &&
                        <kea.AgregarButton onClick={this.onAgregar} />
                    }
                </kea.Title>
                <kea.Grid2 columnas={cols} cookieKey={"DescargaZEListCookieKey"} items={this.items} />
                {this.modalManager.component}
            </div>
        )
    }
}

const DescargaZEListRX = componentToRx(DescargaZEListNoRX);
export class DescargaZEList extends React.PureComponent {
    session = () => resources.User.SessionRx;
    idChoferZE = createSelectorRx(this.session, session => (session.IdChoferZE || undefined));

    render() {
        const idChoferZE = this.idChoferZE(this.props);
        return (
            <DescargaZEListRX idChofer={idChoferZE} permisos={resources.User.PermisoRx} />
        )
    }
}

type Entity2 = models.FiltroCrearCargaZE;

interface ModalProps extends kea.ModalProps<Entity2, Entity2|null, undefined> {
}

export function validar(x: Entity2) {
    const rules: validation.Rules<Entity2> = {
        IdChofer : validation.required
    };
    return validation.getErrors(rules, x);
}

class CrearDescargaModal extends React.PureComponent<ModalProps> {
    value = (props: Entity2) => props;
    errors = createSelectorRx(this.value, x => validar(x));
    getField = formfields(() => this.props, () => this.errors(this.props.value));

    onCerrar = () => {
        if (this.props.value != null) {
            this.props.value.IdChofer = 0
        }
        this.props.onClose(this.props.value);
    }

    render() {
        
        const value = this.props.value  ;
        const Proveedor = this.getField(selectores.UsuarioZEByUserRol);
        const ValueNull = value == null;
        const ChoferZE = this.getField(selectores.ChoferZEByUserZE ( ValueNull ? 0 : ( value.IdProveedor == null ? 0 : value.IdProveedor )  ));
        return (
            <kea.Modal
                onClose={this.onCerrar}
                buttons={[
                    <kea.GuardarButton onClick={() => this.props.onClose(null)} disabled={validation.hasError(this.errors(this.props.value))} />
                ]}
                title="Crear Inicio de descarga"
            >
                {kea.autogrid(3, [
                    <Proveedor field="IdProveedor" label="Proveedor" />,
                    <ChoferZE field="IdChofer" label="Chofer" />
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/descargaze/list/list.tsx